// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppIsUnderConstruction_root__7HWUM {
  display: flex;
  min-height: 100vh;
  width: 100%;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.AppIsUnderConstruction_logo__i0Nlx {
  padding-top: 40px;
  width: 92px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.AppIsUnderConstruction_title__uLLdT {
  font-weight: 500;
  font-size: 20px;
  color: #000000;
  margin-bottom: 26px;
}

.AppIsUnderConstruction_image__n3g6s {
  width: 180px;
  max-width: 90vw;
  margin: auto;
}

.AppIsUnderConstruction_content__MMgb3 {
  text-align: center;
  margin: 100px 0 50px;
  padding: 0 20px;
}

.AppIsUnderConstruction_subtitle__\\+Bjgn {
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
}

.AppIsUnderConstruction_description__6ylG0 {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8E8E93;
}`, "",{"version":3,"sources":["webpack://./src/components/errors/AppIsUnderConstruction/AppIsUnderConstruction.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF","sourcesContent":[".root {\n  display: flex;\n  min-height: 100vh;\n  width: 100%;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.logo {\n  padding-top: 40px;\n  width: 92px;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.title {\n  font-weight: 500;\n  font-size: 20px;\n  color: #000000;\n  margin-bottom: 26px;\n}\n\n.image {\n  width: 180px;\n  max-width: 90vw;\n  margin: auto;\n}\n\n.content {\n  text-align: center;\n  margin: 100px 0 50px;\n  padding: 0 20px;\n}\n\n.subtitle {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  color: #000000;\n}\n\n.description {\n  margin-top: 8px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 16px;\n  color: #8E8E93;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AppIsUnderConstruction_root__7HWUM`,
	"logo": `AppIsUnderConstruction_logo__i0Nlx`,
	"title": `AppIsUnderConstruction_title__uLLdT`,
	"image": `AppIsUnderConstruction_image__n3g6s`,
	"content": `AppIsUnderConstruction_content__MMgb3`,
	"subtitle": `AppIsUnderConstruction_subtitle__+Bjgn`,
	"description": `AppIsUnderConstruction_description__6ylG0`
};
export default ___CSS_LOADER_EXPORT___;
